import IOTDevice from './IOTDevice.js'

export default class UnknownDevice extends IOTDevice {
  constructor(device_guid, device_attributes = false) {
    super(device_guid, device_attributes)
    
    this.device_type = 'unknown'
  }
}